/* OSHA STORE — Required consent gate for Games + PlayStation Plus */
(function () {
  if (window.__oshaProductConsentBound) return;
  window.__oshaProductConsentBound = true;

  function getScope(element) {
    return element.closest('.product-details') || element.closest('.product-information') || document;
  }

  function syncBlock(block) {
    if (!block) return;
    const checkbox = block.querySelector('[data-osha-product-consent-checkbox]');
    if (!checkbox) return;
    const scope = getScope(block);
    const locked = !checkbox.checked;
    scope.querySelectorAll('.osha-game-product-whatsapp').forEach(function (button) {
      button.classList.toggle('is-consent-locked', locked);
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });
    if (!locked) {
      block.classList.remove('has-error');
      const error = block.querySelector('[data-osha-product-consent-error]');
      if (error) error.hidden = true;
    }
  }

  function init(root) {
    const base = root && root.querySelectorAll ? root : document;
    base.querySelectorAll('[data-osha-product-consent]').forEach(syncBlock);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-osha-product-consent-checkbox]')) return;
    syncBlock(event.target.closest('[data-osha-product-consent]'));
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.osha-game-product-whatsapp');
    if (!button) return;
    const scope = getScope(button);
    const block = scope.querySelector('[data-osha-product-consent]');
    if (!block) return;
    const checkbox = block.querySelector('[data-osha-product-consent-checkbox]');
    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    block.classList.add('has-error');
    const error = block.querySelector('[data-osha-product-consent-error]');
    if (error) error.hidden = false;
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () { checkbox.focus({ preventScroll: true }); }, 220);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-osha-product-consent]') || node.querySelector('[data-osha-product-consent]')) {
          init(node.matches('[data-osha-product-consent]') ? node.parentElement : node);
        }
      }
    }
  });
  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
})();
